import { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import { translate } from 'i18n/i18n'
import { captureFrontendError } from 'utils/captureFrontendError'

export const mapApiDeviceVendorToLabel = (
  deviceVendor: SharedTypes.IrrigationScheduler.EIrrigationVendorName,
) => {
  switch (deviceVendor) {
    case SharedTypes.IrrigationScheduler.EIrrigationVendorName.altrac: {
      return translate.phrases.banyanApp('Altrac')
    }

    case SharedTypes.IrrigationScheduler.EIrrigationVendorName.nelson: {
      return translate.phrases.banyanApp('Nelson')
    }

    case SharedTypes.IrrigationScheduler.EIrrigationVendorName.wiseconn: {
      return translate.phrases.banyanApp('Wiseconn')
    }

    default: {
      deviceVendor satisfies never

      captureFrontendError(`IrrigationVendorName "${deviceVendor}" has not been implemented`)

      return deviceVendor
    }
  }
}
